module.exports = __webpack_public_path__ + "img/guest-active.1d445f25.png";